import { TCargoRow } from '@types';
import { withPlural } from './withPlural';
import { formatNumber } from './formatNumber';
import { getCargoQuantityTotals } from './getCargoQuantityTotals';

/* ["4 Qty", "3 Spaces", "10.00 m³", "1,200 kg"] - a Pallets/Bundle/Skid/Other shipment's totals in the one format
   every screen shows them in: the Booking Details side panels list them as-is and getMixedCargoTransportDescription
   joins them into a line. Qty counts every item (1 bundle + 3 pallets = 4 Qty); spaces only come from rows booked
   by pallet spaces. Each segment is omitted when zero. */
export const getCargoQuantitySegments = (rows: TCargoRow[]): string[] => {
	const { items, spaces, cubic, weight } = getCargoQuantityTotals(rows);
	return [
		items ? `${items} Qty` : '',
		spaces ? `${spaces} ${withPlural('Space', spaces)}` : '',
		cubic ? `${cubic.toFixed(2)} m³` : '',
		weight ? `${formatNumber(weight, { maximumFractionDigits: 0 })} kg` : ''
	].filter(Boolean);
};
